module.exports = __webpack_public_path__ + "img/jin.3d587298.jpg";